module.exports = __webpack_public_path__ + "img/eivind-berre-l.53569618.webp";